// extracted by mini-css-extract-plugin
module.exports = {"linkRow":"ChatLink_linkRow__1xDgD","linkText":"ChatLink_linkText__1oKuT","copyPill":"ChatLink_copyPill__1vcyB","copied":"ChatLink_copied__3LRtg"};